
export default function About() {
  const stats = [
    { value: '99.9%', label: 'Uptime Guarantee' },
    { value: '24/7', label: 'Support Available' }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-xs uppercase tracking-widest text-gray-400 mb-6">
            WHO WE ARE
          </p>
          <div className="max-w-3xl ml-auto">
            <h2 className="text-3xl font-serif text-gray-900 leading-relaxed">
              We are a dedicated team of iOS development experts committed to creating innovative mobile applications that prioritize user security, performance, and seamless experience across all Apple devices.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-12 lg:gap-20">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div
                className="text-5xl lg:text-6xl font-bold mb-3 bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent"
              >
                {stat.value}
              </div>
              <div className="text-base text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
